import React, { useEffect } from 'react';

import { RichText } from '@wordpress/block-editor';

import { createRoot } from 'react-dom/client';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import Icon from './icon';

const containers = document.querySelectorAll('#accordionito');
containers.forEach(function(container) {
  const root = createRoot(container);
  root.render(<Accordionito />);

  function Accordionito(cc,dd) {


    const attributes = {
      summary: JSON.parse(container.getAttribute("summary")),
      details: (container.getAttribute("details")),
      icon: JSON.parse(container.getAttribute("icon")),
      iconColor: JSON.parse(container.getAttribute("iconColor")),
      isChecked: JSON.parse(container.getAttribute("isChecked"))
    };

    return (
      <>
        <Accordion >
          <AccordionSummary aria-controls="panel-content" className={attributes.isChecked ? "" : "accordion-no-icon"}>
          <div className='accordion-icon'>
            <Icon iconprop={attributes.icon}  />
          </div>
            <RichText.Content
              value={ "<p>" + attributes.summary + "</p>" }
            />
          </AccordionSummary>
          <AccordionDetails>
          <RichText.Content
              value={ "<p>" + attributes.details.replaceAll('#####', 'a href') + "</p>" }
            />
          </AccordionDetails>
        </Accordion>
      </>
    );
  }
});